/**
 * Debug URL Display Component
 * Shows URL information for debugging (only when DEBUG_SHOW_URLS = true)
 */
import { AlertTriangle } from 'lucide-react';
import { DEBUG_SHOW_URLS } from '../../utils/api';

const DebugUrlDisplay = ({ url, label }) => {
  if (!DEBUG_SHOW_URLS) return null;
  
  // Prüfe auf alte Fork-Referenzen
  const forkCheck = window.FORK_GUARD?.checkUrl(url) || { valid: true };
  const isOldFork = !forkCheck.valid;
  
  return (
    <div className={`text-xs p-1 mt-1 rounded break-all ${isOldFork ? 'bg-red-100 border border-red-500 text-red-700' : 'bg-gray-100 text-gray-600'}`}>
      {isOldFork && (
        <div className="flex items-center gap-1 text-red-600 font-bold mb-1">
          <AlertTriangle className="w-3 h-3" />
          ⚠️ VERALTETE URL: {forkCheck.oldFork}
        </div>
      )}
      <span className="font-semibold">{label}:</span> {url || 'KEINE URL'}
    </div>
  );
};

export default DebugUrlDisplay;
